class MotoReveal extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-moto-scroller]');
    this.lines = this.querySelectorAll('[data-moto-line]');
    this.ticking = false;

    if (!this.scroller) return;

    this.onScroll = this.onScroll.bind(this);
    // Horizon scrolls inside .page-wrapper on desktop instead of the window,
    // and scroll events don't bubble, so we listen on the capture phase at
    // the document level to catch scrolling from any ancestor container.
    document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.onScroll, { capture: true });
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.updateProgress();
      this.ticking = false;
    });
  }

  updateProgress() {
    const rect = this.scroller.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const scrollableDistance = rect.height - viewportHeight;

    let progress;
    if (scrollableDistance <= 0) {
      progress = rect.top <= 0 ? 1 : 0;
    } else {
      progress = Math.min(1, Math.max(0, -rect.top / scrollableDistance));
    }

    this.style.setProperty('--progress', progress.toFixed(3));
    this.lines.forEach((line, index) => {
      line.style.setProperty('--line-speed', `${120 + index * 60}px`);
    });
  }
}

if (!customElements.get('moto-reveal')) {
  customElements.define('moto-reveal', MotoReveal);
}
